























import { defineComponent } from '@vue/composition-api';

import FreshDialog from '@/components/FreshDialog.vue';
import RegisterNewUserMenu from './RegisterNewUserMenu.vue';
import UpdateUser from './UpdateUser.vue';
import UserMetricsMenu from './UserMetricsMenu.vue';

import {
  registerNewUserMenu,
  updateUserMenu,
  userMetricsMenu,
} from '../state';

export default defineComponent({
  name: 'User',
  components: {
    FreshDialog,
    RegisterNewUserMenu,
    UpdateUser,
    UserMetricsMenu,
  },
  setup() {
    return {
      registerNewUserMenu,
      updateUserMenu,
      userMetricsMenu,
    };
  },
});
